import { render, staticRenderFns } from "./ViewBallot.vue?vue&type=template&id=23ca8b21"
import script from "./ViewBallot.vue?vue&type=script&lang=js"
export * from "./ViewBallot.vue?vue&type=script&lang=js"
import style0 from "./ViewBallot.vue?vue&type=style&index=0&id=23ca8b21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports